// extracted by mini-css-extract-plugin
module.exports = {"singup_button":"styles_singup_button__1DSws","checkbox_link":"styles_checkbox_link__23TH5"};